import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const Services: React.FC = () => {
  return (
    <div className="services-page">
      <div className="container">
        <div className="page-title">
          <h1>Our Professional Services</h1>
          <p>Comprehensive trading solutions for professional investors</p>
        </div>
        
        <div className="service-grid">
          <div className="service-card">
            <h3>Education</h3>
            <p>Comprehensive educational resources for traders of all levels</p>
            <Link to="/services/education" className="btn">Start Learning</Link>
          </div>
          
          <div className="service-card">
            <h3>Webinar Training</h3>
            <p>Live interactive sessions with professional traders</p>
            <Link to="/services/webinar" className="btn">Join Webinar</Link>
          </div>
          
          <div className="service-card">
            <h3>Free Trading Signals</h3>
            <p>Professional trading signals with detailed analysis</p>
            <Link to="/services/signals" className="btn">Get Signals</Link>
          </div>
        </div>
        
        <div className="service-info">
          <h2>Why Choose Our Services?</h2>
          <p>UPM Traders offers a comprehensive suite of professional trading services designed to help you achieve your financial goals. Our team of experienced traders and analysts provide you with the tools and knowledge needed to succeed in the markets.</p>
          
          <div className="service-features">
            <div className="feature">
              <h3>Expert Analysis</h3>
              <p>Get market insights from professional traders with proven track records</p>
            </div>
            <div className="feature">
              <h3>Real-Time Updates</h3>
              <p>Receive real-time trading signals and market updates</p>
            </div>
            <div className="feature">
              <h3>Ongoing Support</h3>
              <p>Access to our support team and trading community</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;